export default __webpack_public_path__ + "static/media/reload-warn.841045b8.svg";